export default {
  proxyOrganizationLogo: 'Organization logo',
  proxyUploadLogo: 'Upload logo',
  proxyRemoveLogo: 'Remove',
  proxyLogoHint: 'PNG / JPG / WebP, up to 5 MB. Prefilled for invited account verification and editable.',
  proxyLogoUploadFailed: 'Could not upload the logo',

  changeProxyGroup: 'Change group contact',
  proxyContactLabel: 'Contact',
  proxyEmailLabel: 'Email',
  poster_defaultTitle: 'Event registration',
  poster_details: 'Registration details',
  poster_group: 'Group',
  poster_open: 'Registration open',
  poster_closed: 'Registration closed',
  poster_approved: 'Approved',
  poster_approvedMessage: 'Your registration is approved',
  poster_rejected: 'Not approved',
  poster_rejectedMessage: 'Your registration was not approved',
  poster_pending: 'Pending review',
  poster_pendingMessage: 'Submitted, awaiting review',
  poster_submitted: 'Submitted',
  poster_submittedMessage: 'Your registration details are saved',
  poster_viewDetails: 'View registration details',
  poster_scanQr: 'Press and hold to scan',

  shareAction: 'Share',
  shareGenerating: 'Generating…',
  shareDialogTitle: 'Share event',
  shareSaveTip: 'This image contains your registration details. On your phone, press and hold the image to save it, then share it with friends.',
  sharePosterAlt: 'Event registration poster',
  shareClose: 'Close',
  shareDefaultTitle: 'Event registration',
  shareSaveImage: 'Save image',
  shareFailed: 'Could not generate the poster. Please try again later.',
  recordOrderLockedNotice: 'An order has been created for this registration. Registration details cannot be edited at this time.',
  reviewReasonLabel: 'Review comments: ',
  questionnaireSubmitted: 'Questionnaire submitted',
  submittedAtLabel: 'Submitted at: ',
  reviewPendingMessage: 'Your registration has been submitted. Please wait while we review it.',
  reviewApprovedMessage: 'Your registration has been approved.',
  reviewRejectedMessage: 'Your registration was not approved. Please contact the organizer if you have any questions.',
  reviewSubmittedMessage: 'Your registration details have been submitted.',
  reviewReminder: 'Submitting a registration does not confirm approval. Attendance eligibility depends on the review result. Please contact the organizer for further information.',
  recordReadonlyNotice: 'This registration is read-only. Editing is disabled or the editing deadline has passed.',
  recordDuplicateNotice: 'You have already registered. Please do not submit again.',
  recordClosedNotice: 'Registration is closed. You can still view your submitted details.',
  recordLimitNotice: 'You have reached the submission limit.',
  recordReopenNotice: 'Your registration has been submitted. You can reopen the questionnaire to edit your details.',
  recordEditNotice: 'You have already registered. You can edit your details and submit again.',
  searchProxyGroup: 'Search groups',
  recordQuotaNotice: 'The submission limit of {count} for this {identity} {period} has been reached.',
  quotaAccount: 'account',
  quotaDevice: 'device',
  quotaIp: 'IP address',
  quotaTotal: 'in total',
  quotaDay: 'today',
  quotaWeek: 'this week',
  quotaMonth: 'this month',

  recordPending: 'Pending review',
  recordApproved: 'Approved',
  recordRejected: 'Rejected',
  recordSubmitted: 'Submitted',
  myRecordsTitle: 'My registrations',
  addRecord: 'Add',
  noRecords: 'No registrations yet',
  viewOrEdit: 'View / Edit',
  viewRecord: 'View',
  backToRecords: 'Back to registrations',
  activityStartLabel: 'Event starts: ',
  viewDetails: 'View registration details',

  enableEnglish: 'Enable English version',
  defaultLanguage: 'Default language',
  missingEnglish: '{count} English texts are missing; Chinese will be used',
  fieldEnglishCopy: 'Field English text',
  formEnglishCopy: 'Questionnaire English text',
  englishFallbackHint: 'Chinese source is shown in grey. Blank English text falls back to Chinese. Business rules are shared.',
  englishCopyPlaceholder: 'Enter English text',
  copy_title: 'Questionnaire title',
  copy_description: 'Description',
  copy_submitText: 'Submit button',
  copy_successMessage: 'Success message',
  copy_feeDescription: 'Fee description',
  copy_afterSubmitButton: 'After-submit button',
  copy_afterSubmitText: 'After-submit text',
  copy_placeholder: 'Placeholder',
  copy_patternMessage: 'Validation message',
  copy_detailPlaceholder: 'Address placeholder',
  copy_content: 'Content',
  copy_unit: 'Unit',
  copy_option: 'Option text',

  phoneCountryCode: 'Calling code',
  phoneNumberLabel: 'Phone number',
  phoneLegacyHint: 'The calling code is unclear. Please check the code and full number before editing.',
  fieldTransfer: 'Airport / station transfer',
  submissionFeeMeeting: 'Event session',
  submissionFeeDetails: 'Fee details',
  submissionFeeTotal: 'Total',
  feeSummaryOnlyOne: 'Only one fee summary component can be added per questionnaire',
  meetingNeedsActivity: 'Link this questionnaire to an event before adding event meetings',
  meetingConfigureHint: 'Select event sessions and set their prices',
  meetingChooseActivity: 'Event',
  meetingChooseActivityPlaceholder: 'Select an event',
  meetingChooseActivityHint: 'Select an event, then choose its sessions and set prices.',
  meetingCanvasEmpty: 'Select an event and sessions in the properties panel',
  meetingPrice: 'Session price',
  meetingPricePlaceholder: 'Blank means free',
  meetingFree: 'Free',
  meetingPriceInvalid: 'Use a non-negative session price with up to two decimals, no more than CNY 9999999.99',
  meetingFeeTitle: 'Session fees',
  meetingFeeTotal: 'Session fee total',
  feePerPerson: 'person',
  feeSummaryTitle: 'Event registration fees',
  feeSummaryAutoTitle: 'Automatic registration fee summary',
  feeSummaryAutoHint: 'Displays registration fees, session fees and hotel package prices. Actual charges are calculated from the selections.',
  feeSummaryPreviewHint: 'Editor preview. Actual fees depend on selected sessions, hotel packages and the number of nights.',
  hotelFeeTitle: 'Hotel package fees',
  hotelFeeTotal: 'Hotel fee total',
  hotelFeePerNight: 'night',
  hotelFeePreviewHint: 'Available nightly package rates. Actual charges depend on the selected package and the number of nights.',
  questionnaireShareTitle: 'Questionnaire sharing',
  questionnaireShareOpenDialog: 'View in dialog',
  questionnaireShareDialogTitle: 'Share questionnaire · {title}',
  questionnaireShareActivity: 'Linked event',
  questionnaireShareActivityPlaceholder: 'No event (standalone questionnaire)',
  questionnaireShareActivityHint: 'Share the questionnaire by default. Select a linked event to switch the link and QR code to its registration entry. Clear the selection to return to standalone sharing.',
  questionnaireShareHint: 'Standalone questionnaires exclude linked event sessions and hotels. Event links show the corresponding event registration content. Share the link or QR code. Save after changing the cover.',
  questionnaireShareLink: 'Share link',
  questionnaireShareCopy: 'Copy',
  questionnaireShareQr: 'Questionnaire QR code',
  questionnaireShareDownload: 'Download questionnaire QR code',
  questionnaireShareUnavailable: 'Save the questionnaire to generate its share link',
  questionnaireShareQrFailed: 'Could not generate the QR code. Reopen the sharing panel.',
  questionnaireShareCover: 'Questionnaire cover',
  questionnaireShareCoverUpload: 'Upload questionnaire cover',
  questionnaireShareCoverPlaceholder: 'Cover',
  questionnaireSharePreview: 'WeChat share card preview',
  questionnaireShareDetails: 'View details',
  questionnaireShareDraftHint: 'This questionnaire is a draft. Publish it before participants can use the link or QR code.',
  settingsSectionRules: "Registration controls",
  settingsAllowEditingHint: "Users can reopen, edit and resubmit an existing registration. This updates the same record.",
  settingsCloseRegistrationHint: "Closes new H5 and contact registrations for all linked events. Only the event creator can add registrations in the dashboard.",
  recordNameLabel: "Registration record title",
  recordNameFieldsPlaceholder: "First two input fields by default",
  recordNameSuffixPlaceholder: "Custom text (max 20)",
  recordNameSuffixLabel: "Custom text for the registration title",
  recordNameHint: "Combine answers from up to three selected fields. Custom text is appended to the end of the title.",
  submissionLimitsTitle: "Submission limits",
  submissionLimitsAccount: "Limit per account",
  submissionLimitsDevice: "Limit per device (phone / computer / tablet)",
  submissionLimitsIp: "Limit per IP address",
  submissionLimitsDeviceHint: "Uses browser cookies. Clearing cookies or switching browsers resets this device limit.",
  submissionLimitsIpHint: "Users on the same network may share an IP address. Use with care for schools, workplaces and other shared networks.",
  submissionLimitsPeriod: "Counting period",
  submissionLimitsTotal: "In total",
  submissionLimitsDay: "Per day",
  submissionLimitsWeek: "Per week",
  submissionLimitsMonth: "Per month",
  submissionLimitsSubmit: "Allow",
  submissionLimitsTimes: "submission | submissions",
  submissionLimitsCount: "Submission count",
  submissionLimitsChooseRule: "Select at least one submission limit.",
  submissionLimitsInvalidCount: "Enter a whole number of submissions from 1 to 999999.",
  pageTitle: 'Questionnaires',
  noAccessAlert: 'You do not have questionnaire management permission.',
  createForm: 'New questionnaire',
  defaultFormTitle: 'Untitled questionnaire',
  searchPlaceholder: 'Search questionnaire name',
  /** Form list tip (design-aligned) */
  listTip: 'Use presets in event registration settings, or create reusable questionnaires to avoid repeating field setup.',
  noDescription: 'No description',
  fieldCountLabel: '{n} fields',
  submissionCountLabel: '{n} submissions',
  updatedAtLabel: 'Updated {time}',
  editorTitle: 'Questionnaire designer',
  tabEdit: 'Edit',
  tabSettings: 'Settings',
  settingsPageTitle: 'Registration settings',
  settingsSectionBasic: 'Basic settings',
  settingsSectionCopy: 'Copy & messages',
  settingsSectionWechatShare: 'WeChat share',
  settingsWechatShareTip: 'Configure the WeChat share card title, subtitle and cover. Saved with the form. If bound to an event, use the event Share page instead.',
  settingsWechatShareBoundTip: 'This questionnaire is linked to an event. Configure WeChat share in the event Share settings.',
  settingsWechatTitle: 'Share title',
  settingsWechatTitlePlaceholder: 'Optional; falls back to the form title',
  settingsWechatSubtitle: 'Subtitle',
  settingsWechatSubtitlePlaceholder: 'Optional, shown under the title',
  settingsWechatImage: 'Share image',
  settingsWechatImageHint: 'Recommended 16:9 ratio, JPG/PNG, up to 2MB. Shown in WeChat share cards.',
  settingsWechatImageUpload: 'Upload cover',
  settingsWechatImageUploading: 'Uploading…',
  settingsWechatImageUploadSuccess: 'Cover uploaded',
  settingsWechatImageUploadFailed: 'Upload failed, please try again',
  settingsWechatImageClear: 'Remove image',
  settingsWechatImageTypeError: 'Only JPG / PNG images are supported',
  settingsWechatImageSizeError: 'Image must be 2MB or smaller',
  settingsWechatNeedSaveFirst: 'Save the questionnaire before uploading a cover',
  settingsSectionMeetings: 'Linked meetings',
  allowDuplicateTipOn: 'On: reopen and edit the previous submission (still one record)',
  editExistingNotice: 'You already submitted this form. You can edit and resubmit.',
  defaultSaveEditText: 'Save changes',
  tabStatistics: 'Statistics',
  tabSubmissions: 'Registrations',
  submissionRecordsTitle: 'Registrations',
  statsTotal: 'Total registrations',
  statsPageHint: 'This page',
  tabOrders: 'Orders',
  basicFieldTypes: 'Basic types',
  commonFieldBank: 'Quick fields',
  advancedFieldTypes: 'Advanced',
  comingSoon: 'Coming soon',
  addQuestion: 'Add question',
  formDescriptionPlaceholder: 'Add description (optional)',
  formDescriptionImageNotSupported: 'Images are not supported in the form description',
  deleteField: 'Delete',
  duplicateField: 'Duplicate',
  publish: 'Publish',
  publishConfirm: 'Publish this form?',
  publishSuccess: 'Published',
  settingsSubmitText: 'Submit button text',
  settingsSuccessMessage: 'Success message',
  settingsAfterSubmitTitle: 'Show after registration',
  settingsAfterSubmitEnabled: 'Show action',
  settingsAfterSubmitButtonText: 'Button label (up to 8 characters)',
  settingsAfterSubmitMode: 'On click',
  settingsAfterSubmitText: 'Show text',
  settingsAfterSubmitImage: 'Show image',
  settingsAfterSubmitLink: 'Open link',
  settingsAfterSubmitContent: 'Content',
  settingsAfterSubmitUpload: 'Upload image',
  settingsAfterSubmitLinkPlaceholder: 'Enter an http:// or https:// URL',
  settingsAfterSubmitImageTypeError: 'Only JPG, PNG and WebP images are supported',
  settingsAfterSubmitImageSizeError: 'Image must be 5MB or smaller',
  settingsAfterSubmitUploadSuccess: 'Image uploaded',
  settingsAfterSubmitUploadFailed: 'Image upload failed',
  settingsAfterSubmitButtonInvalid: 'Enter a button label of up to 8 characters',
  settingsAfterSubmitContentRequired: 'Enter text to display',
  settingsAfterSubmitImageRequired: 'Upload an image to display',
  settingsAfterSubmitLinkInvalid: 'Enter a valid http or https URL',
  statsEmpty: 'No submissions yet',
  statsParticipant: 'Participant',
  statsMeeting: 'Meeting',
  statsLoadFailed: 'Failed to load submissions',
  formTitlePlaceholder: 'Form title',
  fieldPalette: 'Fields',
  fieldProps: 'Properties',
  propLabel: 'Label',
  propRequired: 'Required',
  propPlaceholder: 'Placeholder',
  propContent: 'Content',
  option: 'Option',
  addOption: 'Add option',
  removeOption: 'Remove option',
  visibilityLabel: 'Visibility',
  visibilityNone: 'None',
  visibilityHas: 'Conditional',
  visibilitySourceField: 'Depends on',
  visibilitySourcePlaceholder: 'Select radio/select/checkbox field',
  visibilitySourceEmpty: 'Add a radio, select, or checkbox field above first',
  visibilityValue: 'Show when value',
  visibilityValuePlaceholder: 'Select option',
  visibilityWhen: 'Show when {hint}',
  visibilityHiddenInPreview: 'Hidden under current preview values',
  visibilitySaveIncomplete: 'Incomplete visibility rule on field "{label}"',
  emptyFields: 'Drag components here, or click to add',
  dragToAdd: 'Drag to preview to add',
  dragSort: 'Drag to reorder',
  dragToDelete: 'Drop here to delete',
  selectFieldHint: 'Select a field to edit',
  previewTitle: 'Preview',
  backToList: 'Back to list',
  publishSettings: 'Publish settings',
  publishStatus: 'Status',
  publishStatusTip: 'Draft: group registration only. Published: individual and group registration can both be enabled.',
  statusDraft: 'Draft',
  statusPublished: 'Published',
  boundActivitiesTag: 'Bound to event',
  linkedActivities: 'Linked events',
  linkedActivitiesPlaceholder: 'Leave empty for standalone',
  linkedActivitiesTip: 'Link to multiple events, or publish via standalone URL.',
  requireApproval: 'Require review',
  requireApprovalYes: 'Yes',
  requireApprovalNo: 'No',
  requireApprovalTip: 'If No, submissions are automatically approved',
  allowDuplicate: 'Allow editing registration information',
  modificationDeadline: 'Editing deadline (Beijing time)',
  modificationDeadlinePlaceholder: 'Select an editing deadline',
  modificationDeadlineHint: 'Registrants can edit before this deadline. When blank, the registration activity end time applies.',
  registrationFeeTitle: 'Registration fee',
  registrationFeeAmount: 'Amount',
  registrationFeeUnit: 'CNY / person',
  registrationFeeDescription: 'Description (optional)',
  registrationFeeDescriptionPlaceholder: 'For example: materials and refreshments',
  registrationFeeEnabledHint: 'On: set a registration fee per person',
  registrationFeeDisabledHint: 'Off: free registration, no registration fee charged',
  registrationFeeHint: 'Enter a positive amount with up to two decimal places. Turn off the fee switch for free registration.',
  registrationFeeInvalid: 'Enter a positive amount with up to two decimals, no more than CNY 9999999.99',
  allowDuplicateMeetingTip: 'When off: one submission per person per form.',
  allowGroupRegistration: 'Allow group registration',
  registrationClosed: 'Close registration entry',
  registrationClosedTip: 'Disable H5 and contact registrations. Only the event creator can add registrations manually.',
  allowGroupRegistrationTip: 'When on, manage contact rosters for proxy data entry.',
  meetingRequired: 'Meeting information missing',
  notLinked: 'This form is not linked to this meeting',
  settingsLinkedMeetings: 'Linked meetings',
  settingsLinkedMeetingsPlaceholder: 'Select at least one meeting',
  settingsLinkedMeetingsTip: 'H5 participants and desktop users must pick one linked meeting.',
  settingsLinkedMeetingsRequired: 'Select at least one linked meeting',
  selectMeetingLabel: 'Select meetings (multiple)',
  selectMeetingPlaceholder: 'Choose meetings to register for',
  selectMeetingRequired: 'Select at least one meeting',
  selectMeetingStepTip: 'Select one or more meetings, then continue to the form.',
  selectMeetingMultiTip: '{count} meeting(s) selected',
  selectProxyLabel: 'Contact person',
  selectProxyPlaceholder: 'Select contact (optional)',
  selectProxyOptionalTip: 'Optional; only published contacts for the selected meeting(s)',
  selectProxyGroupLabel: 'Organization / group',
  selectProxyGroupPlaceholder: 'Select a group',
  selectProxyGroupTip: 'Select a published contact group for this event',
  selectProxyGroupOptionalTip: 'Optional. Select a published contact group for this event, or leave blank if unaffiliated',
  selectProxyGroupRequired: 'Please select a group',
  proxyFilterProxyBatch: 'Contact person',
  h5BatchSubmitSuccess: 'Registered for {count} meeting(s) successfully',
  noLinkedMeetingsHint: 'No meetings are linked to this form. Ask the organizer to link meetings under Registration → Settings and save.',
  defaultSubmitText: 'Submit',
  standalone: 'Standalone',
  activityCount: '{count} event(s)',
  colTitle: 'Form name',
  colStatus: 'Status',
  colActivities: 'Events',
  colApproval: 'Approval',
  colDuplicate: 'Duplicate',
  colSubmissions: 'Submissions',
  colUpdated: 'Updated',
  editForm: 'Enter',
  preview: 'Preview',
  previewDialogTitle: 'Registration link',
  previewDialogTip: 'Scan or copy the link to open the registration page. Login required on H5.',
  previewBlockedWhenBound: 'Already bound to an event. Please preview from the event microsite editor.',
  previewMeetingPlaceholder: 'Optional: meeting ID for parameterized link',
  previewMeetingRequired: 'Enter a valid meeting ID',
  previewApplyMeeting: 'Apply',
  fieldPresets: 'Quick fields',
  propPattern: 'Validation regex',
  propPatternPlaceholder: 'e.g. ^(?:\\+?86)?1[3-9]\\d{9}$|^\\+[1-9]\\d{6,14}$ (empty = no regex check)',
  propPatternMessage: 'Validation message',
  propPatternMessagePlaceholder: 'Custom message on validation failure',
  propMin: 'Min',
  propMax: 'Max',
  propUnit: 'Unit',
  propIdCard: 'ID card check',
  propIdCardUnique: 'Require unique ID card',
  propDateType: 'Date type',
  dateTypeDate: 'Date',
  dateTypeMonth: 'Year-month',
  dateTypeDatetime: 'Date and time',
  dateTypeTime: 'Time',
  propDetailPlaceholder: 'Detail placeholder',
  addressRegionPlaceholder: 'Province / city / district',
  addressDetailPlaceholder: 'Street, building, etc.',
  presetName: 'Name',
  presetWeight: 'Weight',
  presetTime: 'Time',
  presetEducation: 'Education',
  presetPassportNumber: 'Passport number',
  presetPhone: 'Phone',
  presetGender: 'Gender',
  presetIdCard: 'ID card',
  presetBirthDate: 'Birth month',
  presetEmail: 'Email',
  presetYesNo: 'Yes / No',
  presetFeeItem: 'Fee item',
  presetWechat: 'WeChat ID',
  feeAudienceLabel: 'Visible to',
  feeAudienceGuest: 'Individual',
  feeAudienceProxy: 'Contact entry',
  feeAudienceTip: 'Individual: H5/microsite registration. Contact entry: proxy data entry. Used for channel stats and orders.',
  feeItemOptionPriceHint: 'Enter amount in yuan on the right (up to 2 decimals). Option ID is auto-generated and hidden.',
  feeItemOptionPricePlaceholder: 'Amount (yuan)',
  feeItemOptionPriceInvalid: 'Amount must be non-negative with up to 2 decimal places (yuan)',
  feeItemOptionPriceSaveError: 'Invalid amount for option {n} in "{label}". Use a non-negative amount in yuan.',
  presetAddress: 'Address',
  fieldInput: 'Input',
  fieldTextarea: 'Textarea',
  fieldNumber: 'Number',
  fieldDate: 'Date',
  fieldAddress: 'Address',
  fieldCheckbox: 'Checkbox',
  fieldRadio: 'Radio',
  fieldSelect: 'Select',
  fieldMeeting: 'Event meetings',
  fieldHotel: 'Hotel',
  meetingOptionsTip: 'This form is linked to activities: pick which agendas to show. Checking one on the form means attending it.',
  meetingSelectLabel: 'Agendas',
  meetingMultiple: 'Allow multiple selections',
  meetingSelectPlaceholder: 'Select agendas to display',
  meetingEmptyList: 'No agendas yet. Add them in activity settings first.',
  meetingOptionsCount: '{n} agenda(s) selected',
  meetingSyncFailed: 'Failed to load activity agendas',
  meetingCardTime: 'Time',
  meetingCardAddress: 'Address',
  meetingCardPlace: 'Venue',
  hotelPlaceholder: 'Select hotel(s)',
  hotelBookingPackage: 'Select a hotel package / room',
  hotelBookingEditHint: 'Choose a hotel, package, and stay dates. Hotel fees use the questionnaire package price multiplied by the number of nights.',
  hotelSelectAsNeeded: 'Select as needed',
  hotelOptionsTip: 'Pick hotels from the library; rooms sync automatically. Rooms without a form price are hidden on H5 (library price is not used).',
  hotelRoomPriceTip: 'Price unit: CNY (up to 2 decimals). Room sync prefills library price; override per event.',
  hotelRoomPricePlaceholder: 'Price (CNY)',
  hotelNoRoomsInOption: 'No rooms for this hotel. Add rooms in the hotel library, then refresh.',
  hotelSelectLabel: 'Hotels',
  hotelSelectPlaceholder: 'Select hotels to sync rooms',
  hotelRefreshRooms: 'Refresh rooms',
  hotelRefreshRoomsSuccess: 'Rooms refreshed (custom prices kept)',
  hotelSyncOptions: 'Sync hotel list',
  hotelOptionsCount: '{n} hotel(s) synced',
  hotelSyncSuccess: 'Hotel list synced',
  hotelSyncFailed: 'Failed to sync hotels',
  hotelEmptyList: 'No hotels available',
  hotelViewDetail: 'View hotel',
  hotelStayDates: 'Stay dates',
  hotelCheckIn: 'Check-in',
  hotelCheckOut: 'Check-out',
  hotelStayRangePlaceholder: 'Select check-in and check-out',
  hotelAccommodationTitle: 'Hotel booking',
  hotelAccommodationTip: 'Quality hotel accommodation is available for this event. You are welcome to book.',
  hotelClearSelection: 'Clear selection',
  hotelOpenList: 'Open hotel list',
  hotelSelectionTitle: 'Select accommodation',
  hotelSelectedStays: '{count} stay(s) selected',
  hotelIncompleteStay: 'Select dates and a room for each stay. Check-out must be after check-in.',
  hotelStayRangeConfirm: 'Confirm',
  hotelNoRooms: 'No rooms available',
  hotelAddStay: 'Add stay dates',
  hotelRemoveStay: 'Remove',
  hotelPerNight: 'night',
  hotelBreakfastInclude: 'Breakfast included',
  hotelBreakfastExclude: 'No breakfast',
  hotelBreakfastOptional: 'Breakfast optional',
  hotelAddress: 'Address',
  hotelPhone: 'Phone',
  hotelStar: 'Star rating',
  hotelFacilities: 'Facilities',
  hotelPackages: 'Room packages',
  hotelSurroundings: 'Surroundings',
  fieldDivider: 'Divider',
  fieldDescription: 'Description',
  advancedMeeting: 'Meeting agenda',
  advancedFile: 'File upload',
  advancedSignature: 'Signature',
  advancedMatrix: 'Matrix',
  advancedScale: 'Scale',
  advancedRating: 'Rating',
  titleRequired: 'Title is required',
  loadFailed: 'Load failed',
  saveSuccess: 'Saved',
  saveFailed: 'Save failed',
  createSuccess: 'Created',
  createFailed: 'Create failed',
  copySuccess: 'Copied',
  copyFailed: 'Copy failed',
  deleteConfirm: 'Delete form "{name}"?',
  deleteSuccess: 'Deleted',
  deleteFailed: 'Delete failed',
  goLogin: 'Sign in',
  loginDialogTitle: 'Sign in to register',
  validateFailed: 'Please complete required fields',
  submitSuccess: 'Submitted',
  submitFailed: 'Submit failed',
  quotaFullAlertTitle: 'Quota full',
  quotaFullAlertConfirm: 'OK',
  duplicateReadonly: 'You have already submitted. Duplicate submissions are not allowed.',
  submittedAt: 'Submitted at',
  submissionStatusPending: 'Pending review',
  submissionStatusApproved: 'Approved',
  submissionStatusRejected: 'Rejected',

  /** Contact person entry · batch panel (settings tab) */
  proxyBatchTitle: 'Contact roster',
  /** Info bar under panel title (design-aligned) */
  proxyBatchDesignTip: 'Contacts can batch-enter registrations for their members; each contact manages their own group roster.',
  proxyBatchTip: 'Select contacts, then click "Send invite". Emails contain only a Magic Link—contacts sign in with their own account. Resend works for previously invited rows. Separate from form publish.',
  proxyImportExcel: 'Import Excel',
  proxyExportExcel: 'Export Excel',
  proxyExportExcelEmpty: 'No contacts to export',
  proxyExportExcelSuccess: 'Exported {count} contact(s)',
  proxyExportExcelFailed: 'Export failed. Please try again.',
  proxyAddRow: '+ Add contact',
  proxyEditRow: 'Edit row',
  proxyMailTemplate: 'Email template',
  proxyMailTemplateNeedActivity: 'Bind an activity before editing the email template',
  proxyPublishBatches: 'Send invite',
  proxyPublishFormFirst: 'Publish the form first, then send invites.',
  proxyPublishWhileDraftTip: 'You can send invites while the form is still a draft. Public participant registration still requires the form to be published/enabled.',
  showHistoricalColumns: 'Show deleted field columns',
  proxyPublishConfirm: 'Send invites to contacts matching the current filters? Accounts will be created/updated and emails sent.',
  proxyPublishSelectFirst: 'Select at least one contact to invite',
  proxyPublishConfirmSelected: 'Send invites to the selected {count} contact(s)? Already invited rows will be emailed again.',
  proxyPublishSuccess: 'Invites sent',
  proxyPublishFailed: 'Failed to send invites',
  proxyFilterStatus: 'Invite status',
  proxyStatusDraft: 'Not invited',
  proxyStatusPublished: 'Invited',
  proxyColName: 'Name',
  proxyColGroupName: 'Group name',
  proxyGroupNamePlaceholder: 'Optional; defaults to contact name',
  proxyColMagicLink: 'Magic Link',
  proxyMagicLinkCopied: 'Invite link copied',
  proxyMagicLinkCopyFailed: 'Copy failed; please select the link manually',
  proxyColPhone: 'Phone',
  proxyColJobTitle: 'Title',
  proxyColNotifyEmail: 'Notify email',
  proxyColMeeting: 'Meeting',
  proxyColActivity: 'Event',
  proxyColQuota: 'Quota',
  proxyColMaxRegistrations: 'Max registrations',
  proxyMaxRegistrationsTip: 'Leave empty for unlimited; submissions fail when the quota is full',
  proxyQuotaUnlimited: '{used} / ∞',
  proxyQuotaUsedOfMax: '{used} / {max}',
  proxyQuotaUnlimitedShort: '∞',
  proxyEditQuotaTitle: 'Edit quota and organization logo',
  proxyColQuotaUsed: 'Used',
  proxyQuotaSaveSuccess: 'Quota updated',
  proxyQuotaSaveFailed: 'Failed to update quota',
  proxyQuotaBelowUsed: 'Quota cannot be less than used ({used})',
  proxySelectActivity: 'Select event',
  proxySelectActivities: 'Select events (multiple)',
  proxyImportExcelTip: 'Excel columns: group name, name, phone, title, notify email, activity ID, max registrations (optional, empty = unlimited). Empty group name falls back to contact name. Import appends. Download the template first. Max 1000 rows.',
  proxyImportExcelTemplate: 'Download Excel template',
  proxyImportExcelDrop: 'Drop an Excel file here, or click to upload (.xlsx / .xls)',
  proxyImportExcelPreview: '{count} valid row(s) parsed',
  proxyImportExcelTypeError: 'Please upload a .xlsx or .xls file',
  proxyImportExcelParseFailed: 'Failed to parse Excel. Check the file format.',
  proxyImportExcelNoActivity: 'No available event ID to put in the template',
  proxyColPublishStatus: 'Invite status',
  proxyColRegistrationStatus: 'Registration status',
  proxyRegistrationRegistered: 'Registered',
  proxyRegistrationUnregistered: 'Not registered',
  proxyColMailStatus: 'Email status',
  proxyColAccountEmail: 'Contact account',
  proxyResendMail: 'Resend email',
  proxyResendConfirmTitle: 'Confirm invitation resend',
  proxyResendConfirmBound: 'Resending the invitation for "{name}" will clear the account bound to this contact and mark it as unregistered. The contact must activate the new link; existing registrations will remain. Resend?',
  proxyResendConfirmUnbound: 'Resending the invitation for "{name}" will invalidate the old link and send a new one. Resend?',
  proxyResendSuccess: 'Email resent',
  proxyResendFailed: 'Resend failed',
  proxyMailPending: 'Pending',
  proxyMailSent: 'Sent',
  proxyMailFailed: 'Failed',
  proxyMailPolling: 'Refreshing email send status…',
  proxyNameRequired: 'Name is required',
  proxyEmailRequired: 'Notify email is required',
  proxyEmailInvalid: 'Invalid email',
  proxyLoadFailed: 'Failed to load contact roster',
  proxyCreateSuccess: 'Row added',
  proxyCreateBatchSuccess: '{count} row(s) added',
  proxyDeleteConfirm: 'Delete "{name}"?',
  proxyImportSubmit: 'Import',
  proxyImportEmpty: 'No valid rows parsed',
  proxyImportTooMany: 'Maximum 1000 rows per import',
  proxyImportSuccess: 'Appended successfully',

  /** Contact person entry page / magic link */
  proxyAgentLabel: 'Contact',
  proxyContinueEntry: 'Enter next person',
  proxyLogoutConfirm: 'Sign out?',
  proxyConsumeLoading: 'Verifying sign-in link…',
  proxyConsumeInvalid: 'Invalid or expired link. Contact your administrator.',
  proxyConsumeFailed: 'Failed to verify sign-in link. Please try again.',
  proxyConsumeLoginRequired: 'Please sign in to continue to the entry page.',
  proxyInviteSubtitle: 'Sign in or register with your own account; contact access activates after login',
  proxyInviteTitle: 'Contact entry: {form}',
  proxyInviteAccount: 'Login account',
  proxyInviteInvalid: 'Invalid or expired invitation',
  proxyInviteForbidden: 'This invitation was used by another account. Sign out and try again.',
  proxyLoginMustProxy: 'Open the invitation link from your email to sign in',
  proxyActivateSuccess: 'Activated. Opening entry page…',
  proxyActivateFailed: 'Activation failed. Open the email link and sign in again.',
  proxyRegisterHint: 'Self-registration creates a normal account, not contact entry',
  proxyRegisterInviteNote: 'Email registration requires verification and does not auto-activate contact access. Prefer phone registration or return to sign in.',
  proxyEntryHintTitle: 'Use the link from your email',
  proxyEntryHintDesc: 'Contacts must use the Magic Link from your admin. Open the link and sign in or register with your own account.',
  proxyGrantPending: 'Sign in or register; contact entry access activates after successful login.',
  proxyGrantMagicLinkHint: 'The email link only grants access—no password included. Sign in with email, phone, or WeChat; you will land on the events list after activation.',
  proxyGrantWechatDefault: 'Sign in with WeChat scan, email, or phone; contact access activates automatically after login.',
  proxyGrantWechatRequired: 'Account verified. Please scan WeChat to complete sign-in.',
  proxyGrantWechatBindBeforeLogin: 'Scan WeChat to follow the service account and link it to your email before signing in.',
  proxyGrantWechatBoundRelogin: 'WeChat linked. Sign in with email and password, then complete activation.',
  proxyGrantWechatBindFailed: 'This WeChat account cannot be linked to the contact account. Try another WeChat or contact an admin.',
  proxyGrantWechatBindIncomplete: 'WeChat binding incomplete. Please scan again.',
  proxyGrantWechatRebindPending: 'WeChat binding conflict detected. Please confirm in the dialog…',
  proxyGrantWechatRebindTitle: 'WeChat binding conflict',
  proxyGrantWechatRebindMessage: 'This WeChat is linked to another email. Unlink the old account and bind to the current contact email?',
  proxyGrantWechatRebindTarget: 'Contact email: {email}',
  proxyGrantWechatRebindBound: 'Currently linked: {email}',
  proxyGrantWechatRebindConfirm: 'Unlink and bind',
  proxyGrantConsumed: 'This link was already activated. Sign in with your account.',
  proxyGrantExpired: 'This link has expired. Ask your administrator to resend the invitation.',
  proxyAccessRequiresInvite: 'This account is not authorized yet. Open the invitation link from your email.',
  proxyFormListEmpty: 'No authorized forms. Contact your administrator.',
  proxyEntryAction: 'Enter for contact',
  proxyEnterAction: 'Enter',
  listEmpty: 'No questionnaires yet',
  proxyEntryMeetingTitle: 'Select meeting session',
  proxyEntryMeetingTip: 'Choose from meetings linked to this form in Settings. The selection is sent with your submission.',
  proxyEntryMeetingLabel: 'Meeting session',
  proxyEntryMeetingPlaceholder: 'Select meeting session',
  proxyEntryMeetingRequired: 'Please select a meeting session first',
  proxyEntryMeetingMultiTip: '{count} meeting(s) selected',
  proxyEntryMeetingEditTip: 'Meeting session cannot be changed when editing',
  proxyForbidden: 'You are not authorized to enter submissions for this form',
  proxyBackFormList: 'Back to form list',
  proxyWorkbenchNav: 'Contact workbench navigation',
  proxyNavRegistrations: 'Registrations',
  proxyNavOrders: 'Orders',
  proxySubmissionListTitle: 'Contact entries',
  proxySubmissionListSubtitle: 'H5 registrations assigned to you (source=self)',
  submissionListSubtitle: 'Participant H5 submissions; filter by status, meeting, or contact',
  reviewApprove: 'Approve',
  reviewReject: 'Reject',
  reviewApproveConfirm: 'Approve this registration?',
  reviewRejectTitle: 'Reject registration',
  reviewRemarkPlaceholder: 'Remark (optional)',
  reviewApproveSuccess: 'Approved',
  reviewRejectSuccess: 'Rejected',
  submissionEditTitle: 'Edit registration',
  submissionDetailTitle: 'Participant details',
  submissionDetailSectionBasic: 'Registration info',
  submissionDetailSectionMore: 'More',
  submissionTypeLabel: 'Registration type',
  submissionTypeIndividual: 'Individual',
  submissionTypeTeam: 'Team',
  submissionTypeTeamOf: '{team}',
  submissionMeetingReadonlyTip: 'Selected meetings cannot be changed; only form values are editable.',
  submissionDeleteConfirm: 'Delete this submission? The participant may register again via H5.',
  submissionDeleteSuccess: 'Deleted',
  proxySubmissionListEmpty: 'No submissions yet',
  proxySubmissionKeywordPlaceholder: 'Search name, phone, etc.',
  proxyFilterActivity: 'Filter by activity',
  proxyFilterSubmissionStatus: 'Review status',
  proxyColSubmittedAt: 'Submitted at',
  submissionColSource: 'Source',
  submissionSourceH5: 'Self registration',
  submissionSourceProxy: 'Invited registration',
  submissionColPaymentStatus: 'Payment',
  submissionPaymentStatusNone: 'No order',
  proxyAddEntry: 'New entry',
  adminAddEntry: 'Add entry',
  submissionExport: 'Export',
  submissionExportEmpty: 'No submissions match the current filters',
  submissionExportSuccess: 'Exported {count} submissions',
  submissionExportFailed: 'Failed to export submissions. Please try again.',
  proxyEditEntry: 'Edit entry',
  proxySubmitEntry: 'Submit',
  proxyOrdersPlaceholder: 'Orders coming soon',
  proxyBatchSubmitSuccess: '{count} entries submitted successfully',

  /** Registration orders (B-end) */
  orderRecordsTitle: 'Registration fee orders',
  statsOrderTotal: 'Total orders',
  statsOrderRefunded: 'Refund related',
  orderListSubtitle: 'Orders for this form; contacts only see orders they created',
  orderFilterStatus: 'Order status',
  orderColId: 'Order ID',
  orderColStatus: 'Status',
  orderColAmount: 'Amount',
  orderColItemCount: 'Items',
  orderColCreatedAt: 'Created at',
  orderViewDetail: 'Detail',
  orderCancel: 'Cancel order',
  orderCancelConfirm: 'Cancel this order? Only pending payment orders can be cancelled.',
  orderCancelSuccess: 'Order cancelled',
  orderListEmpty: 'No orders yet',
  orderDetailTitle: 'Order detail',
  orderItemsTitle: 'Line items',
  orderCreate: 'Create order',
  orderCreateSuccess: 'Order created',
  orderCreateFailed: 'Failed to create order',
  orderSelectedCount: '{count} selected',
  orderStatusPendingPayment: 'Pending payment',
  orderStatusPaid: 'Paid',
  orderStatusPartiallyRefunded: 'Partially refunded',
  orderStatusCancelled: 'Cancelled',
  orderStatusRefunded: 'Refunded',

  /** Registration order · partial refund */
  orderColRefundedAmount: 'Refunded amount',
  orderItemRefundStatus: 'Refund status',
  orderItemRefundNone: 'None',
  orderItemRefundRefunding: 'Processing',
  orderItemRefundRefunded: 'Refunded',
  orderItemRefundFailed: 'Failed',
  orderRefund: 'Refund',
  orderRefundTitle: 'Partial refund',
  orderRefundSelectedCount: '{count} line item(s) selected',
  orderRefundAmountLabel: 'Refund amount',
  orderRefundReasonLabel: 'Reason',
  orderRefundReasonPlaceholder: 'Optional, up to 256 characters',
  orderRefundTip: 'Selected line items will be refunded in full via WeChat. Refunded submissions can be ordered again.',
  orderRefundConfirm: 'Confirm refund',
  orderRefundSuccess: 'Refund submitted',
  orderRefundFailed: 'Refund failed. Please try again.',
  orderRefundProcessingTip: 'Some items are being refunded. Please try again later.',

  /** Registration order · WeChat Native pay */
  orderPay: 'Pay',
  orderPayTitle: 'WeChat scan to pay',
  orderPayAmountLabel: 'Amount due',
  orderPayScanTip: 'Scan with WeChat to complete payment',
  orderPayCountdown: 'QR code valid for {time}',
  orderPayReusedTip: 'Reusing the current valid payment code',
  orderPayPolling: 'Waiting for payment…',
  orderPaySuccess: 'Payment successful',
  orderPayFailed: 'Failed to start payment. Please try again.',
  orderPayNoCodeUrl: 'Payment QR code unavailable. Please try again.',
  orderPayCancelled: 'Order cancelled or payment expired. Please create a new order.'
}
